<!-- <div *ngFor="let t of tabList" > -->
<mat-progress-bar *ngIf="showLoader" style="margin-top: 2px;" class="col-md-12" mode="indeterminate"></mat-progress-bar>
<mat-tab-group (selectedTabChange)="getDocumentsListFromCategory($event)">
  <mat-tab *ngFor="let t of tabList" [label]="t">
    <div>
      <div class="row">
        <div *ngFor="let n of documentsList" class="col-md-3">
          <mat-card class="m-2" appearance="outlined">
            <mat-card-header>
              <mat-card-title>
                <div class="heading">
                  <div>{{n.doc_name}}</div>
                  <mat-icon style="cursor: pointer;" [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">more_vert</mat-icon>
                  <mat-menu #menu="matMenu">
                    <button (click)="viewdata(n)" mat-menu-item>
                      <mat-icon>visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button (click)="downloaddata2(n)" mat-menu-item>
                      <mat-icon>save_alt</mat-icon>
                      <span>Download</span>
                    </button>
                  </mat-menu>

                </div>

              </mat-card-title>
              <mat-card-subtitle>Version: {{n.doc_version}}</mat-card-subtitle>
              <mat-card-subtitle>{{n.uploaded_on | date}}</mat-card-subtitle>
            </mat-card-header>
            <!-- <mat-card-actions>
                              <button mat-button>Learn More</button>
                            </mat-card-actions> -->
          </mat-card>
        </div>
      </div>
    </div>

  </mat-tab>
</mat-tab-group>
<!-- </div> -->
